import { render, staticRenderFns } from "./ClientAbout.vue?vue&type=template&id=082af1ee&scoped=true&"
import script from "./ClientAbout.vue?vue&type=script&lang=ts&"
export * from "./ClientAbout.vue?vue&type=script&lang=ts&"
import style0 from "./ClientAbout.vue?vue&type=style&index=0&id=082af1ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082af1ee",
  null
  
)

export default component.exports